/* HomeMedix Subscribe & Save cards (Oct 12, 2026; buy-box step 3). Styling: assets/hm-subsave.css. The cards ARE the existing
   Appstle widget (snippets/subscription.liquid), so Appstle still sets the selling plan. This script only:
   1. makes the whole card clickable;
   2. while Buy once is picked, puts "or $x with Subscribe & Save" right after the big price, on its text line (click = pick
      Subscribe & Save); while Subscribe & Save is picked, shows the subscription price (and the struck one-time price) in the
      big price; the phone sticky bar reads that element too;
   3. on Rx items, adds "It covers every delivery while it's valid." to the Rx tick while subscribed. */
(function () {
  if (window.__hmSsInit) return;
  window.__hmSsInit = true;
  var RX_SUB = ' It covers every delivery while it\u2019s valid.';
  var painting = false;
  function q(s, r) { return (r || document).querySelector(s); }
  function subRadio() { return q('.custom-sub input[name="purchase_option"][value="subscription"]'); }
  function isSub() { var i = subRadio(); return !!(i && i.checked); }
  function subPrice() {
    var sp = q('.custom-sub .subscribe-save .subscription-price');
    if (!sp) return null;
    var o = sp.querySelector('.original-price');
    if (!o) return null;
    var was = o.textContent.trim(), now = sp.textContent.replace(o.textContent, '').trim();
    return now && was && now !== was ? { now: now, was: was } : null;
  }
  function priceEl(box) {
    if (!box) return null;
    return box.querySelector('.price--on-sale .price__sale .price-item--sale') || box.querySelector('.price__regular .price-item--regular');
  }
  function paint() {
    if (painting) return;
    painting = true;
    try {
      var box = q('.custom-price-pdpp'), el = priceEl(box), sp = subPrice(), sub = isSub(), p = sub ? sp : null;
      if (el) {
        if (el.dataset.hmssOrig == null) el.dataset.hmssOrig = el.textContent;
        var was = el.parentNode.querySelector('.hmss-was');
        if (p) {
          if (el.textContent.trim() !== p.now) el.textContent = p.now;
          if (!was) { was = document.createElement('s'); was.className = 'hmss-was'; el.insertAdjacentElement('afterend', was); }
          if (was.textContent !== p.was) was.textContent = p.was;
        } else {
          if (el.textContent !== el.dataset.hmssOrig) el.textContent = el.dataset.hmssOrig;
          if (was) was.parentNode.removeChild(was);
        }
      }
      var or = box ? box.querySelector('.hmss-or') : null;
      if (el && sp && !sub) {
        if (!or || or.previousElementSibling !== el) {
          if (or) or.parentNode.removeChild(or);
          or = document.createElement('button');
          or.type = 'button';
          or.className = 'hmss-or';
          or.setAttribute('data-hmss-pick', '');
          el.insertAdjacentElement('afterend', or);
        }
        if (or.getAttribute('data-v') !== sp.now) {
          or.setAttribute('data-v', sp.now);
          or.textContent = 'or ';
          var b = document.createElement('b');
          b.textContent = sp.now;
          or.appendChild(b);
          or.appendChild(document.createTextNode(' with Subscribe & Save'));
        }
      } else if (or) {
        or.parentNode.removeChild(or);
      }
      var ck = q('[data-hmps-rxack]'), lab = ck ? ck.nextElementSibling : null;
      if (lab) {
        if (lab.dataset.hmssOrig == null) lab.dataset.hmssOrig = lab.textContent;
        var t = lab.dataset.hmssOrig + (sub ? RX_SUB : '');
        if (lab.textContent !== t) lab.textContent = t;
      }
    } finally {
      painting = false;
    }
  }
  function watch() {
    [q('.custom-price-pdpp'), q('.custom-sub .subscribe-save .subscription-price')].forEach(function (n) {
      if (n && !n.__hmssW) {
        n.__hmssW = true;
        new MutationObserver(function () { paint(); }).observe(n, { childList: true, subtree: true, characterData: true });
      }
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-hmss-pick]')) {
      var s = subRadio();
      if (s && !s.checked) s.click();
      return;
    }
    var o = t.closest('.custom-sub .option');
    if (o && !t.closest('label, input, select, a, button')) {
      var r = o.querySelector('input[type="radio"]');
      if (r && !r.checked) r.click();
    }
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('.custom-sub')) setTimeout(paint, 0);
  });
  function boot() { watch(); paint(); }
  document.addEventListener('product-info:loaded', function () { setTimeout(boot, 0); });
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
